// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"24269540","703":"ef28978a","787":"d68614a1"}[chunkId] + ".chunk.js";
};